import useSWR from 'swr';
import { fetcher } from 'services/fetcher';
import { ProductReviewsRatingType } from 'types/ProductPageV2/ProductReviews';

export function useProductRating(
  identifier: string | undefined
): {
  rating: ProductReviewsRatingType | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
} {
  const { data: rating, error } = useSWR<ProductReviewsRatingType>(
    identifier
      ? `${process.env.REACT_APP_URL_API_REVIEWS}/rating/${identifier}`
      : null,
    fetcher,
    {
      revalidateOnFocus: false,
      refreshInterval: 0,
      shouldRetryOnError: false,
    }
  );

  return {
    rating,
    error,
  };
}
